<template>
  <div class="card__title-box">
    <div class="card__title-bonus" v-if="bonusAmount">+ {{ bonusAmount }} bonus!</div>
    <div class="card__title-last-chance" v-if="unit === 'joker' && type === 'last-chance'">{{ trans.get('ms:shop.lc_special_offer_header') }}</div>

    <div class="card__title">
      {{ amount }}
      <i class="demo-icon icon-n-joker-coins" v-if="unit === 'joker'"></i>
      <i class="demo-icon icon-n-lova-coins" v-if="unit === 'coin'"></i>
    </div>

    <div class="card__title-desc" v-if="unit === 'coin'">
      {{ trans.get('ms:shop.coins') }}
    </div>
    <div class="card__title-desc" v-if="unit === 'joker'">
      <span>{{ trans.get('ms:shop.jokers') }}</span>
    </div>

    <div class="card__title-package" v-if="unit === 'joker' && !starter && type !== 'last-chance'">{{ trans.get('ms:shop.package') }}</div>
  </div>
</template>

<script>

export default {
  name: 'ElementTitle',
  components: {},
  props: {
    bonusAmount: Number,
    amount: Number,
    unit: String,
    type: String,
    starter: Boolean,
  },
  methods: {},
};
</script>
